(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/graditify-utils/src/utils/price.js
  var require_price = __commonJS({
    "node_modules/graditify-utils/src/utils/price.js"(exports, module) {
      var moneyFormat = "${{amount}}";
      function defaultOption(opt, def) {
        return typeof opt === "undefined" ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ".");
        decimal = defaultOption(decimal, ",");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        const parts = number.split(".");
        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }
      function caseHandler(element, cents) {
        let value = "";
        switch (element) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          default:
            value = "";
        }
        return value;
      }
      var formatMoney = (cents, format) => {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
        const value = caseHandler(formatString.match(placeholderRegex)[1], cents);
        const price = formatString.replace(placeholderRegex, value);
        return `${price.replace("$", "\u20AC")} EUR`;
      };
      module.exports = {
        formatMoney
      };
    }
  });

  // node_modules/graditify-utils/src/utils/query-selector.js
  var require_query_selector = __commonJS({
    "node_modules/graditify-utils/src/utils/query-selector.js"(exports, module) {
      var $Qll2 = (nodes, parent) => [...(parent || document).querySelectorAll(nodes)];
      var $Q2 = (node, parent) => (parent || document).querySelector(node);
      module.exports = {
        $Qll: $Qll2,
        $Q: $Q2
      };
    }
  });

  // node_modules/graditify-utils/src/utils/to-html.js
  var require_to_html = __commonJS({
    "node_modules/graditify-utils/src/utils/to-html.js"(exports, module) {
      var support = () => {
        if (!window.DOMParser) return false;
        const parser = new DOMParser();
        try {
          parser.parseFromString("x", "text/html");
        } catch (err) {
          return false;
        }
        return true;
      };
      var stringToHTML = (str) => {
        if (support()) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(str, "text/html");
          return doc.body;
        }
        const dom = document.createElement("div");
        dom.innerHTML = str;
        return dom;
      };
      module.exports = {
        stringToHTML
      };
    }
  });

  // node_modules/graditify-utils/src/utils/toggle-dataset.js
  var require_toggle_dataset = __commonJS({
    "node_modules/graditify-utils/src/utils/toggle-dataset.js"(exports, module) {
      var { $Q: $Q2 } = require_query_selector();
      var overlayActions = (id, active, node) => {
        const idOverlay = `overlay--${id}`;
        const parent = node.parentNode;
        if (!active) {
          const overlay = document.createElement("div");
          overlay.setAttribute("id", idOverlay);
          overlay.classList.add("overlay");
          parent.insertBefore(overlay, node);
          toggleDataActive(`#${idOverlay}`, `#${id}`, { overlay: true });
        } else {
          parent.removeChild($Q2(`#${idOverlay}`));
        }
      };
      var isActive = ({ active }) => active === "true";
      function dataToggle(node, overlay) {
        const { dataset, id } = node;
        const active = isActive(dataset);
        if (active) {
          dataset.active = "false";
        } else {
          dataset.active = "true";
        }
        overlay && overlayActions(id, active, node);
      }
      var toggleDataActive = (control, node, config = {}) => {
        if (!$Q2(control)) return;
        const { overlay, closeSelector } = config;
        $Q2(control).addEventListener("click", () => {
          dataToggle($Q2(node), overlay);
        });
        closeSelector && $Q2(closeSelector).addEventListener(
          "click",
          () => {
            dataToggle($Q2(node), overlay);
          }
        );
      };
      module.exports = {
        toggleDataActive,
        dataToggle
      };
    }
  });

  // node_modules/graditify-utils/src/index.js
  var require_src = __commonJS({
    "node_modules/graditify-utils/src/index.js"(exports, module) {
      var { formatMoney } = require_price();
      var { $Q: $Q2, $Qll: $Qll2 } = require_query_selector();
      var { stringToHTML } = require_to_html();
      var { toggleDataActive, dataToggle } = require_toggle_dataset();
      module.exports = {
        stringToHTML,
        formatMoney,
        toggleDataActive,
        dataToggle,
        $Q: $Q2,
        $Qll: $Qll2
      };
    }
  });

  // src/utils/numeric-validation.js
  var forceNumeric = (e) => {
    e.target.value = e.target.value.replace(/[^\d]/, "");
  };

  // src/utils/query-selector.js
  var $Q = (node, parent) => (parent || document).querySelector(node);

  // src/components/form-contact.js
  var validateForm = (e) => {
    e.preventDefault();
    const form = e.target.closest("form");
    const checkAccept = $Q("#validation", form);
    const requiredInputs = [...form.elements].filter((tag) => tag.required).every((tag) => tag.value);
    if (!checkAccept.checked || !requiredInputs) {
      $Q(".error-check-js").style.display = "flex";
      return false;
    }
    $Q(".error-check-js").style.display = "none";
    return form.submit();
  };
  var validateFormContact = () => {
    $Q(".send-contact").addEventListener("click", validateForm);
    $Q('input[type="number"]').addEventListener("input", forceNumeric);
  };

  // src/components/content-page.js
  var import_graditify_utils = __toESM(require_src());
  var collapsiblePosts = () => {
    (0, import_graditify_utils.$Qll)('[data-id^="postId-"]').forEach((post) => {
      const expandButton = post.querySelector(".expand-btn");
      const collapseButton = post.querySelector(".collapse-btn");
      const contentText = post.querySelector(".post-section__content--content-text");
      expandButton.addEventListener("click", function() {
        contentText.classList.add("expanded");
        expandButton.style.display = "none";
        collapseButton.style.display = "inline-block";
      });
      collapseButton.addEventListener("click", function() {
        contentText.classList.remove("expanded");
        expandButton.style.display = "inline-block";
        collapseButton.style.display = "none";
      });
    });
  };

  // src/templates/page.js
  collapsiblePosts();
  validateFormContact();
})();
